<template>
    <div>
        <FieldLabel v-if="prop.show" :label="item.name" :help="showFieldHelp ? fieldHelp : null" :field-id="item.id" :modal-key="modalKey" />
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="auto"
            v-if="prop.show"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="translateResult"
                    @click:append="menu = true"
                    v-bind="attrs"
                    readonly
                    v-on="on"
                    dense
                    :rules="prop.modelRules"
                    :outlined="prop.outlined"
                    :filled="prop.filled"
                    :solo="prop.solo"
                    :hint="prop.description"
                    :persistent-hint="prop.persistenthint"
                    :disabled="prop.disabled"
                    :class="prop.class"
                    :clearable="prop.clearable"
                    :color="prop.coloronselect"
                    @click:clear="clearValue"
                    :prepend-icon="(prop.iconlr=='prepend' && prop.iconinout=='out') ? prop.iconmdi : ''"
                    :prepend-inner-icon="(prop.iconlr=='prepend' && prop.iconinout!='out') ? prop.iconmdi : ''"
                    :append-icon="(prop.iconlr=='append' && prop.iconinout!='out') ? prop.iconmdi : ''"
                    :append-outer-icon="(prop.iconlr=='append' && prop.iconinout=='out') ? prop.iconmdi : ''"
                ></v-text-field>
            </template>
            <v-card class="timeonly-card">
                <v-card-title class="d-flex justify-space-between align-center">
                    <span>{{ fixedDateLabel }}</span>
                    <span class="timeonly-display">{{ formattedInput }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-row
                        dense
                        v-for="(row, rowIndex) in numpadRows"
                        :key="rowIndex"
                        class="timeonly-row"
                    >
                        <v-col
                            cols="4"
                            v-for="(key, keyIndex) in row"
                            :key="`${rowIndex}-${keyIndex}`"
                        >
                            <v-btn
                                block
                                outlined
                                color="primary"
                                class="timeonly-key"
                                @click="onKeyPress(key)"
                            >
                                {{ key }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-2">
                        <v-col cols="12">
                            <v-btn block text color="secondary" @click="resetBuffer">Reinitialiser</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="cancel">Annuler</v-btn>
                    <v-btn text color="primary" @click="apply">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'

export default {
    name: 'timeOnlyPicker',
    mixins: [mixinFields, mixinConditionsFields],
    data() {
        return {
            translateResult: '',
            menu: false,
            modelTime: '00:00',
            baseDate: '',
            initialTime: '',
            inputBuffer: '',
            applied: false,
            loaded: false
        }
    },
    computed: {
        fixedDateLabel() {
            if(!this.baseDate) return 'Date non definie';
            return this.moment(this.baseDate).format('DD/MM/YYYY');
        },
        formattedInput() {
            if(this.inputBuffer.length === 0) {
                return '--:--';
            }
            const padded = this.inputBuffer.padEnd(4, '_');
            return `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
        },
        numpadRows() {
            return [
                ['1', '2', '3'],
                ['4', '5', '6'],
                ['7', '8', '9'],
                ['00', '0', 'DEL']
            ];
        }
    },
    watch: {
        valField(val) {
            this.setInitialValue(val)
        },
        menu(val) {
            if(val) {
                const hasValue = this.translateResult !== 'Choisir une heure' && this.modelTime !== '00:00';
                this.initialTime = hasValue ? this.modelTime : '';
                this.inputBuffer = hasValue && this.modelTime ? this.modelTime.replace(':', '') : '';
                this.applied = false;
            } else if(!val && !this.applied) {
                if(this.initialTime) {
                    this.modelTime = this.initialTime;
                    this.inputBuffer = this.initialTime.replace(':', '');
                    const combined = this.combineDateAndTime(this.modelTime);
                    this.translateResult = this.moment(combined).format('DD/MM/YYYY HH:mm');
                } else {
                    this.modelTime = '00:00';
                    this.inputBuffer = '';
                    if(this.translateResult !== 'Choisir une heure') {
                        this.translateResult = 'Choisir une heure';
                    }
                }
            }
        }
    },
    methods: {
        setInitialValue(value) {
            if(!value || value === '0000-00-00 00:00:00') {
                this.baseDate = this.moment().format('YYYY-MM-DD');
                this.modelTime = '00:00';
                this.inputBuffer = '';
                this.translateResult = 'Choisir une heure';
                this.loaded = true;
                return;
            }
            const parsed = this.moment(value);
            if(!parsed.isValid()) {
                this.baseDate = this.moment().format('YYYY-MM-DD');
                this.modelTime = '00:00';
                this.inputBuffer = '';
                this.translateResult = 'Choisir une heure';
                this.loaded = true;
                return;
            }
            this.baseDate = parsed.format('YYYY-MM-DD');
            this.modelTime = parsed.format('HH:mm');
            this.inputBuffer = this.modelTime.replace(':', '');
            this.translateResult = parsed.format('DD/MM/YYYY HH:mm');
            this.loaded = true;
        },
        clearValue() {
            this.modelTime = '00:00';
            this.inputBuffer = '';
            this.translateResult = 'Choisir une heure';
            const combined = this.combineDateAndTime(this.modelTime);
            this.change(this.item, combined);
            this.changeStoreOnField({ item: this.item, model: combined, page: this.modalKey });
            this.applied = true;
        },
        apply() {
            const normalized = this.normalizeBuffer(this.inputBuffer);
            if(!normalized) {
                this.$toast && this.$toast.warning('Veuillez saisir une heure complete');
                return;
            }
            this.modelTime = normalized;
            this.inputBuffer = normalized.replace(':', '');
            this.translateResult = this.moment(this.combineDateAndTime(this.modelTime)).format('DD/MM/YYYY HH:mm');
            const combined = this.combineDateAndTime(this.modelTime);
            this.change(this.item, combined);
            this.changeStoreOnField({ item: this.item, model: combined, page: this.modalKey });
            this.applied = true;
            this.menu = false;
        },
        cancel() {
            if(this.initialTime) {
                this.modelTime = this.initialTime;
                this.inputBuffer = this.initialTime.replace(':', '');
                const combined = this.combineDateAndTime(this.modelTime);
                this.translateResult = this.moment(combined).format('DD/MM/YYYY HH:mm');
            } else {
                this.modelTime = '00:00';
                this.inputBuffer = '';
                this.translateResult = 'Choisir une heure';
            }
            this.applied = false;
            this.menu = false;
        },
        resetBuffer() {
            if(this.initialTime) {
                this.inputBuffer = this.initialTime.replace(':', '');
                this.modelTime = this.initialTime;
            } else {
                this.inputBuffer = '';
                this.modelTime = '00:00';
            }
        },
        onKeyPress(key) {
            if(key === 'DEL') {
                this.removeDigit();
                return;
            }
            if(key === '00') {
                this.appendDoubleZero();
                return;
            }
            this.appendDigit(key);
        },
        appendDigit(digit) {
            if(this.inputBuffer.length >= 4) return;
            this.inputBuffer += digit;
            if(this.inputBuffer.length === 4) {
                const normalized = this.normalizeBuffer(this.inputBuffer);
                if(normalized) {
                    this.modelTime = normalized;
                }
            }
        },
        appendDoubleZero() {
            const available = 4 - this.inputBuffer.length;
            if(available <= 0) return;
            if(available === 1) {
                this.appendDigit('0');
            } else {
                this.appendDigit('0');
                this.appendDigit('0');
            }
        },
        removeDigit() {
            if(this.inputBuffer.length === 0) return;
            this.inputBuffer = this.inputBuffer.slice(0, -1);
            if(this.inputBuffer.length === 0) {
                this.modelTime = '00:00';
            }
        },
        normalizeBuffer(buffer) {
            if(buffer.length !== 4) return null;
            const hours = parseInt(buffer.slice(0, 2), 10);
            const minutes = parseInt(buffer.slice(2, 4), 10);
            if(Number.isNaN(hours) || Number.isNaN(minutes)) return null;
            const safeHours = Math.min(Math.max(hours, 0), 23);
            const safeMinutes = Math.min(Math.max(minutes, 0), 59);
            return `${safeHours.toString().padStart(2, '0')}:${safeMinutes.toString().padStart(2, '0')}`;
        },
        combineDateAndTime(timeValue) {
            const base = this.baseDate ? this.baseDate : this.moment().format('YYYY-MM-DD');
            const safeTime = timeValue && timeValue !== '' ? timeValue : '00:00';
            return this.moment(base + ' ' + safeTime + ':00').format('YYYY-MM-DD HH:mm:00');
        }
    },
    mounted() {
        this.setInitialValue(this.valField);
    }
}
</script>

<style scoped>
.timeonly-card {
    max-width: 320px;
}
.timeonly-display {
    font-size: 1.6rem;
    font-weight: 600;
    letter-spacing: 0.05em;
}
.timeonly-row {
    margin-bottom: 8px;
}
.timeonly-key {
    min-height: 56px;
    font-size: 1.2rem;
}
</style>
